import { LinearProgress } from "@mui/material";

interface LinearProgressFlujoProps {
  value: number;
  "data-testid"?: string;
}

/** Barra de progreso estilizada para el flujo de formalización: altura 4px, bordes redondeados, fondo neutro. */
export const LinearProgressFlujo = ({ value, ...rest }: LinearProgressFlujoProps) => (
  <LinearProgress
    variant="determinate"
    value={value}
    {...rest}
    sx={{
      mb: "22px",
      height: 4,
      borderRadius: 999,
      bgcolor: (theme) => theme.palette.tokens?.neutralSoftBg,
      "& .MuiLinearProgress-bar": { borderRadius: 999 },
    }}
  />
);
